import * as React from "react";

import Card, { Recommendation, ClickEvent, CardType } from "./Card";

export interface QnARecommendation extends Recommendation {
	questionId: number;
	questionSnippet?: string;
	positiveReviewCount?: number;
	questionURL: string;
}

export interface QnACardProps extends QnARecommendation {
	click: ClickEvent;
	cardNumber: number;
}

const QnACard = (props: QnACardProps) => {
	const data: CardType = {
		text: props.questionSnippet,
		imageURL: props.imageURL,
		thumbnailURL: props.thumbnailURL,
		positiveReviewsCount: props.positiveReviewCount,
		link: props.questionURL,
		linkText: "See answer",
		id: props.questionId,
		cardNumber: props.cardNumber,
		cardClickHandler: props.click,
	};
	return <Card data={data} />;
};

QnACard.displayName = "QnACard";
export default QnACard;
